export function getCurrentDate () {
  let date = new Date()
  let year = date.getFullYear()
  let month = addZero(date.getMonth() + 1)
  let day = addZero(date.getDate())
  return year + '年' + month + '月' + day + '日'
}

export function formatDate (data) {
  if (!data) return
  let date = new Date(data)
  let year = date.getFullYear()
  let month = addZero(date.getMonth() + 1)
  let day = addZero(date.getDate())
  let hour = addZero(date.getHours())
  let minuts = addZero(date.getMinutes())
  let sec = addZero(date.getSeconds())
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minuts + ':' + sec
}

function addZero (n) {
  return n < 10 ? '0' + n : n
}
